module.exports = __webpack_public_path__ + "media/31.ad1451fa.mp3";